interface TagProps {
  label: string
}

export default function Tag({ label }: TagProps) {
  return (
    <span className="inline-flex items-center border border-border text-text-secondary rounded-full px-3 h-7 text-caption leading-none">
      {label}
    </span>
  )
}
